/* eslint-disable solid/no-innerhtml */

import { createSignal, Match, onMount, Switch } from 'solid-js'
import { render } from 'solid-js/web'
import LargeNavigation from './LargeNavigation'
import SmallNavigation from './SmallNavigation'

export default class {
  constructor(el) {
    const menuDataEl = el.querySelector('.js-navData')
    if (!menuDataEl) return

    const menuData = JSON.parse(menuDataEl.textContent)
    if (!menuData) return

    el.replaceChildren()

    render(() => <Menu data={menuData} container={el} />, el)
  }
}

function Menu(props) {
  const [menuType, setMenuType] = createSignal(null)

  onMount(() => {
    const mediaMatch = window.matchMedia('(min-width: 900px)')

    mediaMatch.onchange = (e) => {
      setMenuType(e.matches ? 'large' : 'small')
    }

    setMenuType(mediaMatch.matches ? 'large' : 'small')
  })

  return (
    <Switch fallback={null}>
      <Match when={menuType() === 'large'}>
        <LargeNavigation {...props} />
      </Match>
      <Match when={menuType() === 'small'}>
        <SmallNavigation {...props} />
      </Match>
    </Switch>
  )
}
